import type { ChartLogoPosition } from 'src/app/impact/models/chart-logo.model';

export enum ImpactGraphType {
  OverviewData = 'overviewData',
  DetailedOverviewData = 'detailedOverviewData',
  SplitTransportOverviewData = 'splitTransportOverviewData',
  OnSiteOverviewData = 'onSiteOverviewData',
  TransportData = 'transportData',
  AccommodationData = 'accommodationData',
  ActivityData = 'activityData',
  FoodData = 'foodData',
  DailyImpactChart = 'dailyImpactChart',
  Ecoscore = 'ecoscore',
}

export interface ImpactChartOptions {
  lang: string;
  perTraveler: boolean;
  selectedGraphs?: ImpactGraphType[];
  /** Logo overlaid on every chart of the PDF. Must stay in sync with gt-api ImpactChartOptions. */
  logoPosition?: ChartLogoPosition;
  /** 'company' for the trip's own company, otherwise a client company id. */
  logoSourceId?: string;
}
